export const legendFormatter = (name: string, unit?: string | null) => {
  if (unit) {
    return `${name} (${unit})`;
  }

  return name;
};
